export function getChartTheme(isDark) {
  return {
    grid: isDark ? 'rgba(148, 163, 184, 0.12)' : 'rgba(226, 232, 240, 0.65)',
    axis: isDark ? '#94a3b8' : '#94a3b8',
    accent: '#f97316',
    accentMuted: '#fdba74',
    areaOpacity: 0.28,
    areaOpacityStacked: 0.22,
    tooltip: {
      backgroundColor: isDark ? 'rgba(30, 41, 59, 0.92)' : 'rgba(255, 255, 255, 0.97)',
      border: isDark ? '1px solid rgba(249, 115, 22, 0.15)' : '1px solid rgba(251, 146, 60, 0.18)',
      borderRadius: '14px',
      color: isDark ? '#f1f5f9' : '#334155',
      boxShadow: isDark
        ? '0 16px 40px rgb(0 0 0 / 0.35)'
        : '0 12px 32px rgba(249, 115, 22, 0.08), 0 4px 12px rgb(15 23 42 / 0.04)',
      padding: '10px 14px',
      fontSize: '13px',
    },
    colors: {
      primary: '#f97316',
      primarySoft: '#fb923c',
      success: '#22c55e',
      successSoft: '#86efac',
      amber: '#f59e0b',
      slate: '#94a3b8',
    },
  };
}

/** Softer area series defaults for Recharts */
export function areaSeriesProps(color, opacity = 0.28) {
  return {
    type: 'monotone',
    stroke: color,
    strokeWidth: 2,
    fill: color,
    fillOpacity: opacity,
    dot: false,
    activeDot: { r: 4, strokeWidth: 0, fill: color },
  };
}
